import { getMeetingTypeLabel } from "@pathwright/blocks-core"
import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText, MetaText } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"
import { ButtonBlockButton } from "../Button/ui"
import { SubmitInnerUI } from "../Submit/ui"

const MeetingViewWrap = styled(Content.Container)`
  /* Override Block styles */
  .BlockText p,
  .ContentText,
  .MetaText {
    // ignore blocks styles
    color: #292e35 !important;
  }
`

const MeetingView = ({ data, theme }) => {
  const { templateVariables } = useBlocksConfig()
  const typeLabel = getMeetingTypeLabel(data.link)
  const buttonColor = theme ? theme.primaryBrandColor : ""

  return (
    <MeetingViewWrap flexForPrint={true}>
      <SubmitInnerUI>
        <BlockText
          style={{
            textAlign: "center",
            lineHeight: "1.4"
          }}
          html={data.description}
          templateContext={templateVariables}
        />
        <Content.Text style={{ textAlign: "center", margin: "1rem 0" }}>
          <ButtonBlockButton
            link={data.link}
            buttonColor={buttonColor}
            label={data.buttonLabel}
          />
          {typeLabel ? (
            <MetaText style={{ fontSize: "14px" }} text={typeLabel} />
          ) : null}
        </Content.Text>
      </SubmitInnerUI>
    </MeetingViewWrap>
  )
}

export default MeetingView
